import React from 'react';
import {
  Table,
} from 'react-bootstrap';

import '../style.css';

const PerDiemLegend = () => {
  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>Symbol</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>X</td>
            <td>Did not work</td>
          </tr>
          <tr>
            <td>O</td>
            <td>Not on a Job</td>
          </tr>
          <tr>
            <td>
              <span className="unpaid-per-diem color-block-width">&nbsp;</span>
            </td>
            <td>No Per Diem</td>
          </tr>
          <tr>
            <td>
              <span className="paid-per-diem color-block-width">&nbsp;</span>
            </td>
            <td>Paid Per Diem</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default PerDiemLegend;
